import Vue from "vue";

class ERPService {
  static get resource() {
    return "accounting/erp-post";
  }

  /**
   * Check active ERP integration for a business
   * @param {string} businessId - UUID of the business
   * @returns {Promise} Promise that resolves with integration details or rejects if no integration
   */
  static checkIntegration(businessId) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(this.resource, {
        params: {
          business_id: businessId
        }
      })
        .then(({ data: responseData }) => {
          resolve(responseData);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  /**
   * Download ERP data for a business
   * @param {Object} data - The ERP download request data
   * @param {string} data.business_id - UUID of the business
   * @param {string} data.platform - ERP platform (QUICK_BOOKS, XERO, ZOHO, DYNAMICS, ODOO, WAFEQ)
   * @param {string} data.business_name - Name of the business
   * @param {Array<string>} data.to_emails - Array of recipient email addresses
   * @param {Array<string>} [data.cc_emails] - Array of CC email addresses (optional)
   * @param {boolean} [data.calculate_payer_score] - Whether to calculate payer score for the export
   * @returns {Promise} Promise that resolves with the API response
   */
  static downloadERPData(data) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(this.resource, data)
        .then(({ data: responseData }) => {
          resolve(responseData);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

export default ERPService;
